<app-page-header [pageTitle]="'Push to Corrective Action'" [backgroundColor]="'blue'"></app-page-header>
<ng-container *ngIf="!loading">
  <section>
    <div class="mb-1 display-flex justify-content-between align-items-center">
      <div class="display-flex align-items-baseline">
        <h3 class="mb-0 mt-0 mr-2">Systemic Noncompliance</h3>
      </div>
    </div>

    <mat-card>
      <h4 class="text-primary mb-2">Policies and Procedures Review</h4>
      <div class="table-overflow">
        <table mat-table matSort class="w-100" [dataSource]="policyProcedureDataSource">
          <ng-container matColumnDef="federalRegulationCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Regulation Code</th>
            <td mat-cell *matCellDef="let element">
              {{ element.federalRegulationCode }}
            </td>
          </ng-container>

          <ng-container matColumnDef="federalRegulationCodeShortDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Short Description</th>
            <td mat-cell *matCellDef="let element">
              {{ element.federalRegulationCodeShortDescription }}
            </td>
          </ng-container>

          <ng-container matColumnDef="push">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Push as Systemic Noncompliance?</th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox color="primary" [(ngModel)]="element.selected"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="noResults">
            <td mat-footer-cell *matFooterCellDef colspan="7">
              <i>No results...</i>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="policyProcedureDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: policyProcedureDisplayedColumns"></tr>
          <tr
            mat-footer-row
            *matFooterRowDef="policyProcedureDataSource?.data?.length === 0 ? ['noResults'] : []"
            [hidden]="policyProcedureDataSource?.data?.length !== 0"
            class="example-second-footer-row text-left"
          ></tr>
        </table>
        <mat-paginator [dataSource]="policyProcedureDataSource"></mat-paginator>
      </div>

      <h4 class="text-primary mb-2">IEP Review</h4>
      <div class="table-overflow">
        <table mat-table matSort class="w-100" [dataSource]="iepReviewDataSource">
          <ng-container matColumnDef="federalRegulationCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Regulation Code</th>
            <td mat-cell *matCellDef="let element">
              {{ element.federalRegulationCode }}
            </td>
          </ng-container>

          <ng-container matColumnDef="federalRegulationCodeShortDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Short Description</th>
            <td mat-cell *matCellDef="let element">
              {{ element.federalRegulationCodeShortDescription }}
            </td>
          </ng-container>

          <ng-container matColumnDef="countOfNonCompliant">
            <th mat-header-cell *matHeaderCellDef mat-sort-header># of Noncompliant Responses</th>
            <td mat-cell *matCellDef="let element">
              {{ element.countOfNonCompliant }}
            </td>
          </ng-container>

          <ng-container matColumnDef="percentNonCompliant">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Percent Noncompliant</th>
            <td mat-cell *matCellDef="let element">
              {{ element.percentNonCompliant | percent }}
            </td>
          </ng-container>

          <ng-container matColumnDef="push">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Push as Systemic Noncompliance?</th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox color="primary" [(ngModel)]="element.selected"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="noResults">
            <td mat-footer-cell *matFooterCellDef colspan="7">
              <i>No results...</i>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="iepReviewDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: iepReviewDisplayedColumns"></tr>
          <tr
            mat-footer-row
            *matFooterRowDef="iepReviewDataSource?.data?.length === 0 ? ['noResults'] : []"
            [hidden]="iepReviewDataSource?.data?.length !== 0"
            class="example-second-footer-row text-left"
          ></tr>
        </table>
        <mat-paginator [dataSource]="iepReviewDataSource"></mat-paginator>
      </div>
    </mat-card>
  </section>

  <section class="mt-2">
    <div class="mb-1 display-flex justify-content-between align-items-center">
      <div class="display-flex align-items-baseline">
        <h3 class="mb-0 mt-0 mr-2">Individual Noncompliance</h3>
      </div>
    </div>
    <mat-card>
      <div class="mb-5" *ngFor="let citation of model?.individualNonCompliances">
        <h4 class="text-primary mb-1">Regulation Code {{ citation.federalRegulationCode }}</h4>
        <div class="short-desc mb-2">
          <strong>Short Description:</strong>
          <span>{{ citation.federalRegulationCodeShortDescription }}</span>
        </div>

        <div class="table-overflow">
          <table
            mat-table
            matSort
            class="w-100"
            [dataSource]="individualDataSource[citation.federalRegulationCodeId]"
            [attr.data-citation-id]="citation.federalRegulationCodeId"
          >
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Learner Name</th>
              <td mat-cell *matCellDef="let learner">
                {{ learner.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="dateOfBirth">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>DOB</th>
              <td mat-cell *matCellDef="let learner">
                {{ learner.dateOfBirth | date: "MM/dd/yyyy" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="stateAssignedId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>State ID</th>
              <td mat-cell *matCellDef="let learner">
                {{ learner.stateAssignedId }}
              </td>
            </ng-container>

            <ng-container matColumnDef="iepStartDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>IEP Start Date</th>
              <td mat-cell *matCellDef="let learner">
                {{ learner.iepStartDate | date: "MM/dd/yyyy" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="iepEndDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>IEP End Date</th>
              <td mat-cell *matCellDef="let learner">
                {{ learner.iepEndDate | date: "MM/dd/yyyy" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="push">
              <th mat-header-cell *matHeaderCellDef>
                <div class="push-header align-items-center">
                  <span>Push as Individual Noncompliance?</span><br />
                  <mat-checkbox
                    color="primary"
                    [checked]="allSelected(citation)"
                    [indeterminate]="isCitationIndeterminate(citation)"
                    (change)="toggleAllLearners(citation, $event)"
                  ></mat-checkbox>
                  <span class="ml-2">Select All</span>
                </div>
              </th>
              <td mat-cell *matCellDef="let learner" (click)="$event.stopPropagation()">
                <mat-checkbox color="primary" [(ngModel)]="learner.selected" (change)="updateCitationAllSelected(citation)"></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="noResults">
              <td mat-footer-cell *matFooterCellDef colspan="6">
                <i>No learners...</i>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="individualDisplayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let learner; columns: individualDisplayedColumns"
              (click)="toggleLearner(citation, learner)"
              class="clickable-row"
            ></tr>
            <tr
              mat-footer-row
              *matFooterRowDef="citation.learners?.length === 0 ? ['noResults'] : []"
              [hidden]="citation.learners?.length !== 0"
            ></tr>
          </table>
        </div>
      </div>
    </mat-card>
  </section>
</ng-container>
<div class="action__row">
  <button mat-raised-button color="primary" (click)="create()" [isBusy]="activeCall" [disabled]="!anySelected">
    Create Corrective Action Plan
  </button>
</div>
